import Vue from "vue";
import App from "./App.vue";
import router from "./router/guard.js";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// 全局样式
import "@/assets/scss/style.scss";
// 自定义插件
import Plugins from "@/plugins/plugins";

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Plugins);


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
